// extracted by mini-css-extract-plugin
export default {"imgdiv":"_8f07dd105b _5396b41155","img":"_47c1a9825a a5e5332d4b"};